import { createUseStyles } from 'react-jss';

import { asTabsLgSelectedStyles } from 'vibo-ui/Menu/style';

const useStyles = createUseStyles(() => ({
  settingsPage: {
    background: 'var(--background-default)',
    height: '100%',

    '& .pageContentHeader': {
      '& .stripeBtn': {
        margin: '0 0 0 auto',
      },
    },
  },

  settingsItem: {
    margin: '0 0 20px 0',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',

    '@media screen and (min-width: 1441px)': {
      margin: '0 0 24px 0',
    },
  },

  content: {
    margin: '16px 0 20px 0',
    display: 'flex',

    '& > .contentArea': {
      width: '100%',

      '&:not(:last-child)': {
        margin: '0 13px 0 0',

        '@media screen and (min-width: 1441px)': {
          margin: '0 16px 0 0',
        },
      },
    },
  },

  label: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    fontWeight: 400,
    fontSize: '13px',
    lineHeight: '19.5px',

    '&.noCard': {
      color: 'var(--text-hint)',
    },

    '&.withAction': {
      cursor: 'pointer',
    },

    '& .viboIcon': {
      margin: '0 8px 0 0',

      '@media screen and (min-width: 1441px)': {
        margin: '0 12px 0 0',
      },
    },

    '& .viboButton': {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
    },

    '& .themeMenu': {
      margin: '0 0 0 16px',

      '& .rc-menu-item-active': {
        backgroundColor: 'transparent',
      },

      '&.isSysThemeUsing': {
        '& .system': {
          ...asTabsLgSelectedStyles,
        },
      },

      '&:not(.isSysThemeUsing)': {
        'body[theme="dark"] & .dark': {
          ...asTabsLgSelectedStyles,
        },

        'body[theme="light"] & .light': {
          ...asTabsLgSelectedStyles,
        },
      },
    },

    '@media screen and (min-width: 1441px)': {
      fontSize: '16px',
      lineHeight: '24px',
    },
  },

  container: {
    height: 'calc(100vh - 40px)',
    padding: '16px 15px',
    userSelect: 'none',

    '& .containerContent': {
      maxHeight: '100%',
      display: 'flex',
      flexDirection: 'column',

      '& .contentArea': {
        minHeight: 'fit-content',
        width: '100%',
        padding: '12px',

        '& .settingsItem': {
          '&:last-child': {
            margin: '0',
          },
        },

        '&:not(:last-child)': {
          margin: '0 12px 0 0',

          '@media screen and (min-width: 1441px)': {
            margin: '0 16px 0 0',
          },
        },

        '@media screen and (min-width: 1441px)': {
          padding: '24px',
        },
      },
    },

    '& .viboButton.linkDisplay': {
      padding: 0,
    },

    '@media screen and (min-width: 1441px)': {
      height: 'calc(100vh - 48px)',
    },
  },

  title: {
    fontWeight: 500,
    fontSize: '13px',
    lineHeight: '19.5px',
    margin: '0 0 12px 0',
    color: 'var(--text-hint)',

    '@media screen and (min-width: 1441px)': {
      margin: '0 0 24px 0',
      fontSize: '16px',
      lineHeight: '24px',
    },
  },

  expiredDate: {
    margin: '0 18px 0 8px',
  },

  successText: {
    color: 'var(--success-main)',
  },

  failText: {
    color: 'var(--error-main)',
  },

  greyText: {
    color: 'var(--text-hint)',
  },

  role: {
    margin: '0 12px',
  },

  spotifyIcon: {
    color: 'var(--clr-mountainMeadow)',
  },

  generalIcon: {
    color: 'var(--text-secondary)',
  },
}));

export default useStyles;
